import { defineComponent, computed } from 'vue';
import { ProsemirrorHelper } from '../../helpers/prosemirror.helper';
export default defineComponent({
    name: 'PricingTableCheckbox',
    props: {
        disabled: { type: Boolean, default: false },
        input: { type: Object, required: true },
    },
    emits: ['update-checked'],
    setup(props, { emit }) {
        const inputId = computed(() => { var _a; return (_a = props.input) === null || _a === void 0 ? void 0 : _a.id; });
        const inputValue = computed(() => { var _a; return (_a = props.input) === null || _a === void 0 ? void 0 : _a.value; });
        const handleUpdateChecked = (checked) => {
            emit('update-checked', Object.assign(Object.assign({}, props.input), { value: checked ? '1' : '0' }), 'optionalProductFieldId');
        };
        return { handleUpdateChecked, ProsemirrorHelper, inputId, inputValue };
    },
});
